import { initializeFedopsApps } from './app-data/app-data';
import { create } from './logger-factory';

angular.module('fedops', []);

angular
  .module('fedops')
  .provider('fedopsLogger', () => {
    return {
      setAppName(name) {
        this.appName = name;
        return this;
      },
      setAppId(appId) {
        this.appId = appId;
        return this;
      },
      /* @deprecated */ useNewRelic() {
        return this;
      },
      setBaseUrl(url) {
        this.baseUrl = url;
        return this;
      },
      setDisableAutoLoadFinish() {
        this.disableAutoLoadFinish = true;
        return this;
      },
      setNetworkAnalysis() {
        this.networkAnalysis = true;
      },
      setPublisher(publisher) {
        this.publisher = publisher;
      },
      $get() {
        return create(this.appName, {
          baseUrl: this.baseUrl,
          appId: this.appId,
          disableAutoLoadFinish: this.disableAutoLoadFinish,
          networkAnalysis: this.networkAnalysis,
          publisher: this.publisher,
        });
      },
    };
  })
  .factory('fedopsLoggerFactory', () => {
    return {
      createWidget: (appName, disableAutoLoadFinish) => {
        return create(appName, {
          isWidgetLogger: true,
          disableAutoLoadFinish,
        });
      },
    };
  })
  .config(() => {
    initializeFedopsApps();
  })
  .config([
    '$provide',
    $provide => {
      $provide.decorator('$exceptionHandler', [
        '$delegate',
        function($delegate) {
          return function(exception, cause) {
            $delegate(exception, cause);
          };
        },
      ]);
    },
  ])
  .run([
    '$injector',
    'fedopsLogger',
    ($injector, fedopsLogger) => {
      $injector.get('$$testability').whenStable(() => {
        if (!fedopsLogger || fedopsLogger.isDisableAutoLoadFinish()) {
          return;
        }
        fedopsLogger.appLoaded();
      });
    },
  ]);
